<template>
  <v-container fluid>
    <v-row v-if="children">
      <v-col>
        <v-card>
          <v-toolbar dense>{{ children.name }}
            <v-spacer/>
            <v-btn color="primary" small :to="{name: 'Session info', params: {session_id: children.id}}">open session</v-btn>
          </v-toolbar>
          <v-simple-table>
            <template v-slot:default>
              <thead>
              <tr>
                <th class="text-left">Start</th>
                <th class="text-left">End</th>
                <th class="text-left">Deadline</th>
                <th class="text-left">Return marked</th>
              </tr>
              </thead>
              <tbody>
              <tr>
                <td>{{ $moment(children.start).format('DD MMMM YYYY hh:mm') }}</td>
                <td>{{ $moment(children.end).format('DD MMMM YYYY hh:mm') }}</td>
                <td>{{ $moment(children.deadline).format('DD MMMM YYYY hh:mm') }}</td>
                <td>{{ $moment(children.return_marked).format('DD MMMM YYYY hh:mm') }}</td>
              </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-card>
      </v-col>
    </v-row>

    <v-row v-if="children">
      <v-col>
        <v-card>
          <v-toolbar dense>Change children session
          </v-toolbar>

          <v-card-text>
            <v-select v-model="mock"
                      :items="session.mock.children"
                      item-text="full_name"
                      item-value="id"
                      return-object
                      outlined
                      dense
                      :error-messages="api_errors['parent_session_id']"
            ></v-select>
          </v-card-text>
          <v-divider/>
          <v-card-actions>
            <v-btn @click="changeChildrenSession">Change</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>

    <v-row v-if="!children">
      <v-col>
        <v-card v-if="session">
         <v-card-text>
           <v-select v-model="mock"
                     :items="session.mock.children"
                     item-text="full_name"
                     item-value="id"
                     return-object
                     outlined
                     dense
                     :error-messages="api_errors['parent_session_id']"
           ></v-select>
         </v-card-text>
          <v-divider/>
          <v-card-actions class="justify-end">
            <v-btn :disabled="!mock" @click="reserveSession">Book</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>

  </v-container>
</template>

<script>
export default {
  props: {
    session: {
      type: Object,
      default: null
    }
  },
  data: () => ({
    children: null,
    mock: null,
    api_errors: []
  }),
  watch: {
    'session': function (val) {
      if(val) {
        this.children = val.children
        if(!this.children) this.mock = this.session.mock.children[0]
      }
    }
  },
  mounted() {
    if(this.session) {
      this.children = this.session.children
      if(!this.children) this.mock = this.session.mock.children[0]
    }
  },
  methods: {
    reserveSession() {
      this.api_errors = []
      this.app_loading = true
      this.axios.post(`api/sessions`, {
        user_id: this.session.user_id,
        parent_session_id: this.session.id,
        session_type_id: this.mock.session_type_id,
        practice_area_id: this.mock.practice_area_id,
        mock_id: this.mock.id,
        start: this.session.start,
        end: this.session.end,
      })
          .then(({data}) => {
            this.children = data.data
            this.$emit('loadSession')
          })
          .catch(errors => {
            this.api_errors = errors.response.data.errors
            this.$emit('loadSession')
          })
          .then(() => {this.app_loading = false})
    },
    changeChildrenSession() {
      this.api_errors = []
      this.app_loading = true
      this.axios.put(`api/sessions/${this.session.id}/children`, {mock_id: this.mock.id,})
          .then(({data}) => {
            this.children = data.data
            this.$emit('loadSession')
          })
          .catch(errors => {
            this.api_errors = errors.response.data.errors
            this.$emit('loadSession')
          })
          .then(() => {this.app_loading = false})
    }
  }
}
</script>
